import { render, staticRenderFns } from "./OrganizationView.vue?vue&type=template&id=85d69eae"
import script from "./OrganizationView.vue?vue&type=script&lang=js"
export * from "./OrganizationView.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports